<template>
  <AuthCard>
    <template #title>
      {{ t('auth.resetPass.title') }}
    </template>

    <template #caption>
      {{ t('auth.resetPass.text') }}
    </template>

    <template #form>
      <form
        @submit="onSubmit"
        :class="$style.form"
      >
        <UiField
          type="email"
          label="Email"
          name="email"
          placeholder="Email"
          :rounded="false"
        />

        <UiButton :loading="loader">
          <template #label>
            {{ t('auth.resetPass.button') }}
          </template>
        </UiButton>
      </form>
    </template>
  </AuthCard>
</template>

<script setup lang="ts">
import { useForm } from 'vee-validate';
import * as yup from 'yup';

const { t } = useI18n();

const toastStore = useToastStore();

const schema: yup.AnyObject = yup.object({
  email: yup.string().email('Invalid email address').required('Email is required'),
});

const loader = ref<boolean>(false);
const { handleSubmit } = useForm({
  validationSchema: schema,
});
const { $localePath } = useNuxtApp();
const onSubmit = handleSubmit(
  async (values): Promise<void> => {
    try {
      loader.value = true;
      const authApi = useNuxtApp().$authApi;

      const { result, data } = await authApi.resetPassword(values.email);

      if (result) {
        toastStore.showSuccess({
          text: t('errors.resetPass.success'),
          duration: 3000,
        });
        navigateTo($localePath('/auth/signin'));
      } 
      
      if (data.statusCode === 400 && data.message === 'emailAlreadySend') {
        toastStore.showDanger({
          text: t('errors.resetPass.emailAlreadySend'),
          duration: 3000,
        });
      }
      if (data.statusCode === 400 && data.message === 'notExistEntity') {
        toastStore.showDanger({
          text: t('errors.resetPass.noUser'),
          duration: 3000,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      loader.value = false;
    }
  }
);
</script>

<style lang="scss" module>
  .form {
    display: flex;
    flex-direction: column;
  }

  .caption {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-top: 15px;

    a {
      color: #293EFF;
      text-decoration: none;
      transition: 200ms ease;

      &:hover {
        color: #293EFF;
        opacity: .8;
      }
    }
  }

  a.createAccountLink {
    color: #596269;
  }
</style>